import axios from "axios";

export default {
  name: "ExistingAccountData",
  props: {
    completeSelection: {
      type: Function,
      required: true,
    },
    filters: {
      type: Object,
      default: null,
    },
  },
  components: {
    DataGridComp: require("@/customcontrols/datagrid.vue").default,
    FilterDataComp: require("@/customcontrols/filterData.vue").default,
    EmptyState: require("@/customcontrols/emptyState/emptyState.vue").default,
  },
  data: function () {
    return {
      showDialog: false,
      filterObj: [],
      options: { pageSize: 10, total: 0, page: 1, totalRow: 0 },
      noDataFound: true,
      selectedCustomer: null,
      customers: [],
      customersCols: [],
      keyColumn: "customerKey",
    };
  },
  created() {
    this.$root.$on("find_customer_updated", this.init);

    this.init();
  },
  methods: {
    async init() {
      this.fillCustomersCols();
      this.fillFiltersObj();

      this.getCustomers();
    },
    fillFiltersObj() {
      this.filterObj = [];
      if (
        this.filters &&
        this.filters.billingGroups &&
        this.filters.billingGroups.length
      ) {
        this.filterObj.push({
          defaultIndex: 0,
          index: 0,
          field: "BillingGroup",
          fieldDesc: this.$t("activities.billingGroup"),
          type: "list",
          listSource: this.filters.billingGroups,
          listValueField: "value",
          listTextField: "text",
          addedDefault: true,
          defaultValue: "-1",
          value: "-1",
          added: true,
        });
      }

      this.filterObj.push({
        defaultIndex: 2,
        index: 2,
        field: "CustomerKey",
        fieldDesc: this.$t("activities.customerKey"),
        type: "text",
        addedDefault: true,
        defaultValue: "",
        value: "",
        added: true,
      });

      this.filterObj.push({
        defaultIndex: 3,
        index: 3,
        field: "Surname",
        fieldDesc: this.$t("activities.surname"),
        type: "text",
        addedDefault: true,
        defaultValue: "",
        value: "",
        added: true,
      });

      if (this.filters && this.filters.consumerTypes.length) {
        this.filterObj.push({
          defaultIndex: 0,
          index: 0,
          field: "ConsumerType",
          fieldDesc: this.$t("activities.consumerType"),
          type: "list",
          listSource: this.filters.consumerTypes,
          listValueField: "value",
          listTextField: "text",
          addedDefault: true,
          defaultValue: "-1",
          value: "-1",
          added: false,
        });
      }

      this.filterObj.push({
        defaultIndex: 4,
        index: 4,
        field: "Initial",
        fieldDesc: this.$t("activities.initial"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 5,
        index: 5,
        field: "Address",
        fieldDesc: this.$t("activities.address"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 6,
        index: 6,
        field: "TelephoneNumber",
        fieldDesc: this.$t("activities.telephoneNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 7,
        index: 7,
        field: "IdNumber",
        fieldDesc: this.$t("activities.idNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 8,
        index: 8,
        field: "PIN",
        fieldDesc: this.$t("activities.pin"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 9,
        index: 9,
        field: "CellPhone",
        fieldDesc: this.$t("activities.cellPhone"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });
    },
    fillCustomersCols() {
      this.customersCols.push({
        dataField: "billingGroupStr",
        caption: this.$t("activities.billingGroup"),
      });
      this.customersCols.push({
        dataField: "customerKey",
        caption: this.$t("activities.account"),
      });
      this.customersCols.push({
        dataField: "surname",
        caption: this.$t("activities.surname"),
      });
      this.customersCols.push({
        dataField: "idNumber",
        caption: this.$t("activities.initial"),
      });
      this.customersCols.push({
        dataField: "address",
        caption: this.$t("activities.address"),
      });
      this.customersCols.push({
        dataField: "consumerTypeStr",
        caption: this.$t("activities.consumerType"),
      });
      this.customersCols.push({
        dataField: "telephoneNumber",
        caption: this.$t("activities.telephoneNumber"),
      });
      this.customersCols.push({
        dataField: "cellPhone",
        caption: this.$t("activities.cellPhone"),
      });
    },
    pageChange(pInfo) {
      if (
        this.options.page == pInfo.pageNumber &&
        this.options.pageSize == pInfo.pageSize
      )
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getCustomers();
    },
    onClick(info) {
      if (info.newRowIndex < 0) {
        this.selectedCustomer = null;
        return;
      }

      var cust = info.rows[info.newRowIndex].data;
      if (cust === null || cust === undefined) return;

      this.selectedCustomer = cust;
    },
    onDblClick(info) {
      if (!info.data) {
        this.selectedCustomer = null;
        return;
      }

      this.selectedCustomer = info.data;
      this.selectCustomerFunc();
    },
    selectCustomerFunc() {
      this.completeSelection(this.selectedCustomer);
      this.showDialog = false;
    },
    getCustomers() {
      var criteria = {};

      for (var i = 0; i < this.filterObj.filter((a) => a.added).length; i++) {
        criteria[this.filterObj.filter((a) => a.added)[i].field] =
          this.filterObj.filter((a) => a.added)[i].value;
      }

      var parameter = {
        Filters: criteria,
        Options: { page: this.options.page, pageSize: this.options.pageSize },
      };

      this.$store.state.notifier.asyncBlock(
        axios.post("/CaptureCustomerActivity/GetCustomers", parameter),
        (resp) => {
          if (resp.status == 200) {
            if (resp.data.items.length == 0) {
              this.customers = [];
              this.noDataFound = true;
            } else {
              this.customers = resp.data.items;
              this.options.total = resp.data.itemsCount;
              this.options.totalRow = resp.data.itemsCount;
            }
          } else this.$alertMsg(resp.data.data.text);
        },
        (err) => {
          this.$alertMsg(err.response.data);
          this.$router.push("/login");
        }
      );
    },

    openDialog() {
      this.showDialog = true;
    },
  },
};
